// extracted by mini-css-extract-plugin
export default {"flex_container":"InformationPageSite_flex_container__rhsZV","text":"InformationPageSite_text__P10VN","img":"InformationPageSite_img__n05dW"};